import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { hasValue } from '../utils/functions/common.functions';

const DEFAULT_SCOPE: string | null = null;

export type ReadOnlyBehaviourSubject<T> =  Observable<boolean> & {
  value: T;
};

@Injectable()
export class SaveSheetService {
  public stayOpen: boolean = false;

  public get openStatus$(): ReadOnlyBehaviourSubject<boolean> {
    return this.openStatus;
  }

  public get savedStatus$(): Observable<boolean> {
    return this.savedStatus;
  }

  private openStatus: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private savedStatus: Subject<boolean> = new Subject<boolean>();
  private scope: string | null = DEFAULT_SCOPE;

  public setScope(scope: string): void {
    if (!hasValue(scope)) {
      this.scope = DEFAULT_SCOPE;
    }
    else {
      this.scope = scope;
    }
  }

  public hasScope(scope: string): boolean {
    return this.scope === scope;
  }

  public change(open: boolean, scope: string | null = DEFAULT_SCOPE): void {
    if (this.scope !== scope) {
      return;
    }
    this.openStatus.next(open);
  }

  public save(): void {
    this.savedStatus.next(true);

    if (this.stayOpen) {
      this.stayOpen = false;
    }
    else {
      this.openStatus.next(false);
    }
  }
}
